<template>
  <header
    id="header"
    class="app-header padding-y-md"
    style="
      background-color: var(--white);
      --button-background: transparent;
      --button-hover-background: transparent;
      --button-margin-bottom: 0;
      --button-padding: var(--spacing-2xs) var(--spacing-md);
      --button-color: var(--fa-md-gravy);
      --button-hover-color: var(--fa-dk-blue);
    "
  >
    <div class="container">
      <div class="wrap-app-header position-relative display-flex flex-items-center flex-content-between size-lg tablet:size-md">
        <site-link
          :to="{ name: 'home' }"
          class="wrapper-logo-flag-animated button flat"
        >
          <owa-logo-flag />
          <span class="sr-only">Font Awesome</span>
        </site-link>

        <slot name="action">
          <site-link
            :to="{ name: 'support' }"
            class="button flat"
            aria-label="Support"
            data-balloon-pos="left"
            @click="$posthog.capture('support_link_click', { context: 'page_header_simple' })"
          >
            <font-awesome-icon
              :icon="$v7.regular.faHeadset"
              size="xl"
            />
            <span class="sr-only">Support</span>
          </site-link>
        </slot>
      </div>
    </div>
  </header>
</template>
